export default __webpack_public_path__ + "static/media/side-banner.d19a42be.png";